import React from 'react';
import { motion } from 'framer-motion';

const Slide12GivingBack: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        One for One Pledge
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-2xl text-[#94a3b8] mb-12 text-center"
      >
        Every paid subscription funds a free license for a disadvantaged student
      </motion.p>

      <div className="flex gap-12 max-w-5xl w-full">
        {/* Left: Stats */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
          className="flex-1 space-y-6"
        >
          <div className="flex items-start gap-5">
            <div
              className="w-16 h-16 rounded-xl flex items-center justify-center text-3xl flex-shrink-0"
              style={{ background: 'rgba(239, 68, 68, 0.2)' }}
            >
              📊
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-white">1 in 6 NSW children</h3>
              <p className="text-lg text-[#94a3b8]">live in poverty without access to quality education</p>
            </div>
          </div>

          <div className="flex items-start gap-5">
            <div
              className="w-16 h-16 rounded-xl flex items-center justify-center text-3xl flex-shrink-0"
              style={{ background: 'rgba(245, 158, 11, 0.2)' }}
            >
              📍
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-white">Rural students</h3>
              <p className="text-lg text-[#94a3b8]">2.5x less likely to complete Year 12</p>
            </div>
          </div>

          <div className="flex items-start gap-5">
            <div
              className="w-16 h-16 rounded-xl flex items-center justify-center text-3xl flex-shrink-0"
              style={{ background: 'rgba(16, 185, 129, 0.2)' }}
            >
              💪
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-white">Education changes lives</h3>
              <p className="text-lg text-[#94a3b8]">3x higher lifetime earnings with quality education</p>
            </div>
          </div>
        </motion.div>

        {/* Right: Impact */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4 }}
          className="flex-1 rounded-xl p-8 flex flex-col justify-center"
          style={{
            background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(6, 182, 212, 0.2) 100%)',
            border: '2px solid rgba(16, 185, 129, 0.4)',
          }}
        >
          <div className="text-center">
            <div className="text-6xl mb-4">🎓</div>
            <h3 className="text-3xl font-bold text-white mb-4">Your Impact</h3>
            <p className="text-xl text-[#94a3b8] mb-6">
              When your school subscribes, you're helping a child in need get the same opportunity.
            </p>
            <div
              className="inline-flex items-center gap-3 px-6 py-3 rounded-full text-xl font-semibold"
              style={{ background: 'rgba(16, 185, 129, 0.3)', color: '#10b981' }}
            >
              <span>1 subscription</span>
              <span>=</span>
              <span>1 child helped</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Slide12GivingBack;
